<template lang="pug">
RogueButton.gc-balance-button(
  :text="__('Check Gift Card Balance')"
  width="full"
  @click="uiStore.showOverlay('giftcard-balance-check', rogue)"
)
</template>

<script setup lang="ts">
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'

const uiStore = useUIStore()
const rogue = useRogue()
</script>

<style lang="scss" scoped>
.giftcard-content .gc-balance-button {
  display: none;
}

@include not-mobile() {
  .gc-balance-button {
    width: auto;
  }

  .giftcard-content .gc-balance-button {
    display: block;
  }

  .rhpa-bottom .gc-balance-button {
    display: none;
  }
}
</style>
